import { createTheme } from '@mui/material'
import { useState, useEffect } from 'react'
import { useStore } from '@/src/types/store'

const useDynamicTheme = (initialTheme: any) => {
  const [currTheme, setCurrTheme] = useState(initialTheme)
  const { themeColours } = useStore()

  useEffect(() => {
    document.documentElement.style.setProperty('--primary-color', themeColours.primary)
    document.documentElement.style.setProperty('--secondary-color', themeColours.secondary)

    const newTheme = createTheme({
      ...initialTheme,
      palette: {
        primary: {
          main: '#07004D',
          dark: '#1501B0',
          light: '#5C48F5'
        },
        text: {
          primary: '#000000DE',
          secondary: '#00000099',
          disabled: '#00000061'
        },
        secondary: {
          main: '#251F62',
          dark: '#7B1FA2',
          light: '#BA68C8'
        }
      }
    })

    setCurrTheme(newTheme)
  }, [initialTheme, themeColours])

  return currTheme
}

export default useDynamicTheme
